import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import sellerAccountService from "../services/sellerAccountService";
import styles from './LoginPage.module.css';
import { useAppContext } from "../context/AppContext";

const VerifyEmailPage = () => {
    const { sellerAccount, setSellerAccount } = useAppContext();

    const { token } = useParams<{ token: string }>();
    const [isTokenValid, setIsTokenValid] = useState(false);
    const isUserLoggedIn = sellerAccount != null;
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [updated, setUpdated] = useState(false);

    const validateToken = async () => {
        if (!token) {
            setIsTokenValid(false);
            return false;
        }

        try {
            const result = await sellerAccountService.verifyEmail(token);
            if (result === "Success") {
                setSuccess("Your email has been successfully verified. You can now access all features of your account.");
                return true;
            }
            else {
                if (result === "InvalidToken") {
                    setError("The email verification token is invalid.");

                } else if (result === "TokenExpired") {
                    setError("The email verification token has expired. Please request a new verification email from the My Account page.");

                }
                else if (result === "Error") {
                    setError("An error occurred during email verification. Please try again later.");

                } else {
                    setError("An unknown error occurred during email verification. Please try again later.");

                }
                return false;
            }
        }
        catch (error) {
            setError("An error occurred while verifying your email. Please try again later.");
            return false;
        }
    }

    useEffect(() => {
        const checkToken = async () => {
            const valid = await validateToken();
            setIsTokenValid(valid);
            

        };

        checkToken();
    }, [token]);

    useEffect(() => {
        if (isTokenValid && isUserLoggedIn && sellerAccount && !updated) {
            setSellerAccount({ ...sellerAccount, emailVerified: true });
            setUpdated(true);
        }
    }, [isTokenValid, sellerAccount, isUserLoggedIn,  updated]);


    return (
        <>
            <div className='d-flex justify-content-lg-center'>
                <Link to="/"><img className={styles.loginLogo} src="/images/tahpi-plus.png" alt=""></img></Link>
            </div>
            <h3 className={`mb-4 text-center ${styles.title}`}>Verify Account Email</h3>
            {success && <div className="alert alert-success mt-2" role="alert">{success}</div>}
            {error && <div className="alert alert-danger mt-2" role="alert">{error}</div>}
            {isTokenValid && !isUserLoggedIn &&
                <Link className="btn btn-lg btn-outline-dark w-100 py-2 mt-3 rounded-0" to="/login">Log in</Link>
            }
            {isTokenValid && isUserLoggedIn &&
                <Link className="btn btn-lg btn-outline-dark w-100 py-2 mt-3 rounded-0" to="/myaccount">Go to My Account</Link>
            }
        </>
    );
}
export default VerifyEmailPage;